// extracted by mini-css-extract-plugin
module.exports = {"container":"_2FI0Brvx1E9qffWhJGJ7cS"};